// extracted by mini-css-extract-plugin
module.exports = {"resaleticket-row":"resaleTicketCard_resaleticket-row__sV_6W","title":"resaleTicketCard_title__3tRQB","value":"resaleTicketCard_value__2mipM"};